import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function AddingProductRow({ subTitle, title, value, isMobile }) {
  return (
    <div className={cx('wrapper', isMobile ? 'wrapperMobile' : null)}>
      {subTitle ?
        <div className={cx('subTitle')}>{subTitle}</div>
      : null}

      <div className={cx('parts')}>
        <div className={cx('partOne')}>
          <div className={cx('title')}>{title}</div>
        </div>
        <div className={cx('partTwo')}>
          <div className={cx('value')}>{value}</div>
        </div>
      </div>
    </div>
  );
}

AddingProductRow.defaultProps = {
  subTitle: '',
  title: '',
  value: null,
  isMobile: false,
};

AddingProductRow.propTypes = {
  subTitle: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any,
  isMobile: PropTypes.bool,
};
